import globalEventBus from 'toxilibs/event_bus_queued.js'
import LayeredScreen from 'toxilibs/layered_screen.js'
import './map.js'
import './player.js'
import './frame.js'
import './error_stats.js'

let eventBus = globalEventBus('renderer')



eventBus.on('ui resized', resize)



let maxCanvasSize = 800


let container
let screenContainer
let screen


function init (_container) {
    container = _container
    screenContainer = container.find('#map')

    screen = new LayeredScreen(screenContainer[0])

    eventBus.emit('screen loaded', screen)
}



function resize () {
    if (!screen || !mapDimensions) {
        return
    }
    resizeCanvas({
        maxPixWidth:  container.innerWidth(),
        maxPixHeight: container.innerHeight()
    })
    resizeScreen()
    eventBus.emit('screen has been reset')
}



function resizeCanvas ({maxPixWidth, maxPixHeight}) {

    let mapSizeToPixelRatio = Math.min(
        Math.min(maxCanvasSize, maxPixWidth)  / mapDimensions.width,
        Math.min(maxCanvasSize, maxPixHeight) / mapDimensions.height
    )

    screenContainer.innerWidth(Math.round(mapDimensions.width   * mapSizeToPixelRatio))
    screenContainer.innerHeight(Math.round(mapDimensions.height * mapSizeToPixelRatio))
}



function resizeScreen () {
    let scale = Math.min(
        screenContainer.innerWidth() / mapDimensions.width,
        screenContainer.innerHeight() / mapDimensions.height
    )

    screen.resize()

    screen.setScale(scale)

    screen.setCenter(mapDimensions.center)

    screenContainer.css('top',  0.5 * (container.innerHeight() - screenContainer.height()) + 'px')

}


let mapDimensions

eventBus.on('map render dimensions changed', function (_mapDimensions) {
    mapDimensions = _mapDimensions
    resize()
})



export default {
    init
}

